module.exports = "https://web-assets.ifttt.com/packs/media/icons/close-36032192.svg";